import React, { useEffect, useState } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
const TOTAL_CUPOS = 200;
const CUPOS_RESTANTES = 37;
const START_SECONDS = 23 * 60 + 41;
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function Countdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const percent = Math.round(CUPOS_RESTANTES / TOTAL_CUPOS * 100);
  return <div className="rounded-2xl border border-amber-400/30 bg-amber-500/10 p-4" data-id="element-54" data-mp="325jaewa9dt3b">
      <div className="flex items-center justify-center gap-2 text-amber-200" data-id="element-55" data-mp="373ba4ch5aji2">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="10dek1p8er3up" />
        <p className="text-xs font-extrabold uppercase tracking-wide" data-id="element-57" data-mp="15bg164m9wt3j">
          La oferta termina en
        </p>
      </div>

      <p className="mt-1 text-center text-4xl font-black tabular-nums text-white" aria-live="off" data-id="element-58" data-mp="y0n5bzzw5tfu">
        {pad(mins)}:{pad(secs)}
      </p>

      <div className="mt-4" data-id="element-59" data-mp="t0934ykz1dpq">
        <div className="flex items-center justify-between text-[11px] font-semibold text-amber-100" data-id="element-60" data-mp="17rhouwlr6exl">
          <span className="inline-flex items-center gap-1" data-id="element-61" data-mp="12rdapd8bhwaj">
            <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="12u954rkyi2u8" />
            Cupos restantes
          </span>
          <span data-id="element-63" data-mp="a37n8ipvpt70">
            {CUPOS_RESTANTES} de {TOTAL_CUPOS}
          </span>
        </div>
        <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL_CUPOS} aria-valuenow={CUPOS_RESTANTES} aria-label="Cupos restantes" data-id="element-64" data-mp="a5k9v96l0rqe">
          <div className="h-full rounded-full bg-amber-400" style={{
          width: `${percent}%`
        }} data-id="element-65" data-mp="1zk8prkedsrt6" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-amber-100/70" data-id="element-66" data-mp="s66bziohmo8s">
          Ya se tomaron {TOTAL_CUPOS - CUPOS_RESTANTES} de los {TOTAL_CUPOS}{' '}
          cupos con bonos incluidos
        </p>
      </div>
    </div>;
}